import axios from "axios";

import { BACKEND_URL } from "../constants"

const listOrders = (startDate, endDate) => {
  const params = new URLSearchParams([
    ["start_date", startDate.toISOString()],
    ["end_date", endDate.toISOString()],
  ]);
  const url = `${BACKEND_URL}/api/v1/orders/s/`;
  return axios.get(url, { params });
}

const retrieveOrder = (orderId) => {
  const url = `${BACKEND_URL}/api/v1/orders/${orderId}/s/`;
  return axios.get(url);
}

export const ordersServices = {
  listOrders,
  retrieveOrder,
};